import { ClientFetch } from '../../fetch/ClientFetch';
import type { AddProductToCartResponse } from '../../../types/cart';
import { HTTP_METHODS } from 'utils';

/**
 * Adds a product to the shopping cart with a default quantity of 1.
 *
 * Makes a POST request to the cart service to add the specified product.
 * The product is always added with a count of 1. For custom quantities,
 * consider using a different cart service method.
 *
 * @param productId - The unique identifier of the product to add to the cart
 * @returns A promise that resolves to an object containing the cart operation token (ot)
 *
 *
 * @throws May throw an error if the service request fails or the product is invalid
 */
export const addProductToCart = async (productId: number): Promise<AddProductToCartResponse> => {
  const payload = {
    productId,
    count: 1,
  };

  return new ClientFetch().makePsiRequest<AddProductToCartResponse>('customer.cart.cartAddProduct', payload, {
    method: HTTP_METHODS.POST,
  });
};
